var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"action-menu-item",class:_vm.active ? 'text-gray-700' : 'text-gray-200',attrs:{"disabled":!_vm.active}},_vm.$listeners),[_c('app-icon',{staticClass:"h-6 w-6 mb-2",attrs:{"name":_vm.icon}}),_vm._v(" "),_c('div',{staticClass:"text-xs"},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }